import { DealerLocationPartToExcludeEnum } from "../../types/utility/dealer.js";
function getDealerAddress(address, exclusion) {
  var _a;
  const city = ((_a = address.city) == null ? void 0 : _a.name) ?? "";
  const district = address.district ?? "";
  const suburb = address.suburb ?? "";
  const microdistrict = address.microdistrict ?? "";
  const street = address.street ?? "";
  const house = address.house ?? "";
  let addressString = "";
  const exclusions = Array.isArray(exclusion) ? exclusion : [exclusion];
  exclusions.forEach((exclusion2) => {
    if (exclusion2 !== DealerLocationPartToExcludeEnum.District) {
      addressString += district.length ? `${district}, ` : "";
    }
    if (exclusion2 !== DealerLocationPartToExcludeEnum.City) {
      addressString += city.length ? `${city}, ` : "";
    }
  });
  addressString += suburb.length ? `${suburb}, ` : "";
  addressString += microdistrict.length ? `${microdistrict}, ` : "";
  addressString += street.length ? street : "";
  addressString += house.length ? `, ${house}` : "";
  if (addressString.endsWith(", ")) {
    addressString = addressString.substring(0, addressString.length - 2);
  }
  return addressString;
}
export {
  getDealerAddress
};
